import React, { Fragment } from 'react';

import type { liveSearchAGGResult } from '../API/handleAGGSearch.tsx';

import { SearchLoading } from './SearchLoading.tsx';
import { SearchResult } from './SearchResult.tsx';
import { SearchNoResults } from './SearchNoResults.tsx';
import { SearchResultMore } from './SearchResultMore.tsx';

interface SearchResultListProps {
	searchResults: liveSearchAGGResult[];
	searchInput: string;
	onClick: (obj: any) => void;
	extraInfo: 'none' | 'excerpt' | 'space';
	loading: boolean;
}

export const SearchResultsList = ({
	searchResults,
	searchInput,
	onClick,
	loading,
	extraInfo,
}: SearchResultListProps) => (
	<div>
		{loading ? (
			<SearchLoading />
		) : searchResults.length > 0 ? (
			<Fragment>
				<div>
					{searchResults.map((result) => (
						<SearchResult
							searchResult={result}
							onClick={onClick}
							extraInfo={extraInfo}
							key={result.id}
						/>
					))}
				</div>
				<SearchResultMore onClick={onClick} searchInput={searchInput} />
			</Fragment>
		) : (
			<SearchNoResults />
		)}
	</div>
);
